




















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import * as s_Interface from '@/interface/store/manageGroups';
import { InventoryQueryParams } from '@/interface/store/inventory';

const namespace: string = 'manageGroup';

@Component
export default class ManageGroup extends Vue {
  @Action('getMe', { namespace }) c_getMe!: any;
  @Action('getGroups', { namespace }) c_getGroups!: any;

  @Getter('getterGroupsMemberships', { namespace }) c_getterGroupsMemberships!: Array<
    s_Interface.GroupItem
  >;
  @Getter('getterLastGroupId') c_getterLastGroupId!: string;
  @Getter('getterMembers', { namespace }) c_getterMembers!: string;
  @Getter('getterQueryParams', { namespace: 'inventory' })
  readonly c_getterInventoryQueryParams!: InventoryQueryParams;

  public activeName: string | undefined = undefined;
  public currentGroupId: string = '';
  public dialogVisible: boolean = false;

  get groupNames() {
    return this.c_getterGroupsMemberships.map((item) => {
      return {
        label: item.fkGroup.name,
        value: item.fkGroup.id,
      };
    });
  }

  get currentGroupData() {
    const groupId: string = this.$route.params.groupId;

    if (this.c_getterGroupsMemberships.length > 0) {
      return {
        ...this.c_getterGroupsMemberships.find(
          (groupItem: s_Interface.GroupItem) => groupItem.fkGroup.id === groupId
        )!.fkGroup,
      };
    }
  }

  async created() {
    try {
      if (!this.c_getterGroupsMemberships.length) await this.c_getGroups();
      await this.c_getMe(this.$route.params.groupId);
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
    this.currentGroupId = this.currentGroupData!.id;
  }

  @Watch('$route', { immediate: true, deep: true })
  onRouteChange(val: any, oldVal: any) {
    this.activeName = val.name;
  }

  routeToBack() {
    this.$router.go(-1);
  }

  routeToClose() {
    this.$router.push(`/groups/${this.$route.params.groupId}`);
  }

  handleClick() {
    this.$router.push({
      name: this.activeName,
    });
  }

  handleSelectGroup(selectedGroupId: string) {
    const routeName: string | undefined | null = this.$route.name;
    if (routeName === 'Members') {
      this.$router.push({
        path: `/manage-groups/${selectedGroupId}/members`,
      });
    } else {
      this.$router.push({
        path: `/manage-groups/${selectedGroupId}/${routeName!.toLowerCase()}`,
      });
    }
  }
}
